import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFan2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 58,
	height: 8,
	viewBox: "0 0 58.0 8.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 4.0 8.0 L 54.0 0.0 A 4.0 4.0 0.0 1 1 54.0 8.0 L 4.0 0.0 A 4.0 4.0 0.0 1 0 4.0 8.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgFan2;
